import { action, computed, observable, set } from 'mobx';
import Abstract from './abstract';

export class Independent extends Abstract {
  @observable public albums = [];
  @observable public classifications = [];
  @observable public busy = { aside: false, main: false };
  @observable public settings;

  @computed get layoutAside() {
    if (!this.settings) return true;
    return 'classificationUuids' in this.settings;
  }

  @action
  setSettings = value => {
    this.settings = value;
  };
}
